// Campus photo for /colleges/university-of-california-berkeley: Public domain, by Carol M. Highsmith, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ASather_Gate_at_University_of_California%2C_Berkeley%2C_California_LCCN2013633500.tif), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-california-berkeley/; credited under the photo.
const photo = {
    "slug": "university-of-california-berkeley",
    "alt": "Sather Gate on the UC Berkeley campus in Berkeley, California",
    "src": "/colleges/university-of-california-berkeley/campus-1600.webp",
    "srcSmall": "/colleges/university-of-california-berkeley/campus-800.webp",
    "srcMid": "/colleges/university-of-california-berkeley/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-california-berkeley/og.jpg",
    "title": "Sather Gate at University of California, Berkeley, California LCCN2013633500",
    "author": "Carol M. Highsmith",
    "license": "Public domain",
    "licenseUrl": null,
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ASather_Gate_at_University_of_California%2C_Berkeley%2C_California_LCCN2013633500.tif",
    "read": "2026-09-30"
};

export default photo;
